import request from "@/utils/request";

// 获取当前登录用户信息
export const getLoginInfo = () => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/hy/getLoginInfo",
    method: "GET",
  });
};

// SSO登录（通过token获取登录信息）
export const ssoLogin = (token) => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/hy/hyxysso",
    method: "POST",
    data: { token },
  });
};

// 生成SSO Token
// export const generateSsoToken = () => {
//   return request({
//     url: "http://hyxytest.hyszpt.com:8030/user/sso/generateSsoToken",
//     method: "GET",
//   });
// };

// 退出登录
export const loginOut = () => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/hy/loginOut",
    method: "GET",
  });
};

// 获取站点详情
export const getNewest = () => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/site/getNewest",
    method: "GET",
  });
};

// 获取平铺的栏目
export const getMenu = () => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/column/listAll",
    method: "GET",
  });
};

// 获取栏目树
export const getMenuTree = () => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/column/tree",
    method: "GET",
  });
};

// 获取广告
export const getAd = (params) => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/ad/page",
    method: "GET",
    params,
  });
};

// 获取友情链接
export const getFriendLink = (params) => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/link/page",
    method: "GET",
    params,
  });
};

// 获取行业分类
export const getDictionaryByDictType = (params) => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/dict/getDictionaryByDictType",
    method: "GET",
    params,
  });
};

// 获取所有搜索列表
export const getSearchList = (params) => {
  return request({
    url: process.env.VUE_APP_APP_API + "/web/property-notice/searchAll",
    method: "GET",
    params,
  });
};
